import { getDistanceFilterOptions, toSitecoreItemOrList } from '../locationSearchFilterConfig';
import { SiteCard } from './mapCoveoResultToCard.types';

export const resolveDefaultDistanceMiles = (defaultDistance: unknown): number | undefined =>
  getDistanceFilterOptions(toSitecoreItemOrList(defaultDistance))[0]?.miles;

const displayedDistanceMiles = (distanceMiles: number): string => distanceMiles.toFixed(1);

export const getClosestSiteIds = (sites: Pick<SiteCard, 'id' | 'distanceMiles'>[]): Set<string> => {
  const closestIds = new Set<string>();
  const firstDistance = sites[0]?.distanceMiles;
  if (typeof firstDistance !== 'number' || !Number.isFinite(firstDistance)) {
    return closestIds;
  }

  const closestDisplayedDistance = displayedDistanceMiles(firstDistance);
  for (const site of sites) {
    if (
      typeof site.distanceMiles !== 'number' ||
      !Number.isFinite(site.distanceMiles) ||
      displayedDistanceMiles(site.distanceMiles) !== closestDisplayedDistance
    ) {
      break;
    }
    closestIds.add(site.id);
  }

  return closestIds;
};
